import { currency_list } from 'data/CurrencyData'

// in params currency code and amount will be passed
export const getFormattedPrice = ({ currency_code, amount }) => {
  const currency = currency_list.find((c) => c.code === currency_code)
  return currency.format.replace('{amount}', amount)
}
